
import axios from '../axios'
// publishAnalysisChart
export const publishAnalysisChart = (data) => {
  return axios({
    url: '/console/homework/publishAnalysisChart',
    method: 'GET',
    data
  })
}
export const publishAnalysisList = (data) => {
  return axios({
    url: '/console/homework/publishAnalysisList',
    method: 'GET',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/publishedJobAnalysis.js